import { render, staticRenderFns } from "./ItemAging.vue?vue&type=template&id=d68cc992&scoped=true"
import script from "./ItemAging.vue?vue&type=script&lang=js"
export * from "./ItemAging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68cc992",
  null
  
)

export default component.exports